import {ngAsync} from 'shared/utils/ng-@decorators';
import type {ActionResponse, Comment, CommentCreationRequest, FinishedSaveResponse} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class CommentsDataService {
    public static serviceName = 'commentsDataService';

    private readonly REQUEST_ROUTE = 'comments';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async loadComments(recordId: string): Promise<Comment[]> {
        return this.ajaxService
            .createRequest(`${this.REQUEST_ROUTE}`)
            .get({document: recordId, viewable: true});
    }

    @ngAsync()
    public async deleteComment(comment: Comment): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${this.REQUEST_ROUTE}/${comment.id}`)
            .delete();
    }

    @ngAsync()
    public async addComment(commentCreationRequest: CommentCreationRequest): Promise<FinishedSaveResponse<Comment>> {
        return this.ajaxService
            .createRequest(`${this.REQUEST_ROUTE}`)
            .post(commentCreationRequest);
    }
}